@if (isLoading()) {

	<div class="overlay">
		<div class="spinner"></div>

		@if (message()) {
			<div class="message" [innerHTML]="message()">
			</div>
		}

	</div>

}
